export const initialState = {
  packages: [],
  userSubscriptions: [],
  // Distinguishes "no live subscription" from "not fetched yet" — an empty
  // list is meaningful input to the membership gate, an unfetched one is not.
  userSubscriptionsLoaded: false,
  nextTokens: { 1: null },
  loading: false,
  error: null,
  unsubscribeStatus: "",
  unsubsribeError: null,
  unsubsribeLoading: false,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "REQUEST_LIST_PACKAGE":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "LIST_PACKAGE_SUCCESS":
      return {
        ...state,
        loading: false,
        packages: action.payload.items,
      };
    case "LIST_PACKAGE_ERROR":
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case "REQUEST_LIST_USER_SUBSCRIPTION":
      return {
        ...state,
        userSubscriptions: [],
        userSubscriptionsLoaded: false,
        nextTokens:
          action.payload.page === 1
            ? initialState.nextTokens
            : state.nextTokens,
        nextToken: null,
        loading: true,
        error: null,
      };
    case "REQUEST_LIST_NEXT_USER_SUBSCRIPTION":
      return {
        ...state,
        nextLoading: true,
        error: null,
        nextError: null,
      };
    case "LIST_USER_SUBSCRIPTION_SUCCESS":
      return {
        ...state,
        loading: false,
        nextLoading: false,
        userSubscriptions: action.payload.append
          ? [...state.userSubscriptions, ...action.payload.items]
          : action.payload.items,
        userSubscriptionsLoaded: true,
        nextToken: action.payload.nextToken,
        nextTokens: {
          ...state.nextTokens,
          [action.payload.nextPage]: action.payload.nextToken,
        },
      };
    case "LIST_USER_SUBSCRIPTION_ERROR":
      return {
        ...state,
        loading: false,
        nextLoading: false,
        error: action.error,
      };
    case "REQUEST_UNSUBSCRIBE_NEWSLETTER":
      return {
        ...state,
        unsubsribeLoading: true,
        unsubsribeError: null,
      };
    case "UNSUBSCRIBE_NEWSLETTER_SUCCESS":
      return {
        ...state,
        unsubsribeLoading: false,
        unsubscribeStatus: action.payload.unsubscribeStatus,
      };
    case "UNSUBSCRIBE_NEWSLETTER_ERROR":
      return {
        ...state,
        unsubsribeLoading: false,
        unsubsribeError: action.error,
      };
    default:
      return state;
  }
};
